import { render, staticRenderFns } from "./RecommendedLineSuspensions.vue?vue&type=template&id=35145f74&"
import script from "./RecommendedLineSuspensions.vue?vue&type=script&lang=js&"
export * from "./RecommendedLineSuspensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports